import { Bell } from "lucide-react";
import { CrudPage } from "../components/crud/CrudPage";
import { useOpciones } from "../hooks/useOpciones";
import { Badge } from "../components/ui/Badge";

const tipos = [
  { value: "CITA", label: "Cita" },
  { value: "VACUNA", label: "Vacuna" },
  { value: "PROMOCION", label: "Promoción" },
  { value: "HOSPEDAJE", label: "Hospedaje" },
];
const canales = [
  { value: "WHATSAPP", label: "WhatsApp" },
  { value: "EMAIL", label: "Correo" },
  { value: "SMS", label: "SMS" },
];

const colorEstado: Record<string, "verde" | "amarillo" | "rojo" | "gris"> = {
  ENVIADO: "verde",
  PROGRAMADO: "amarillo",
  FALLIDO: "rojo",
  CANCELADO: "gris",
};

export default function Recordatorios() {
  const { opciones: clientes } = useOpciones("/clientes", (c) => c.nombre);
  const { opciones: mascotas } = useOpciones("/mascotas", (m) => m.nombre);

  return (
    <CrudPage
      resource="/recordatorios"
          seccion="recordatorios"
      titulo="Recordatorios"
          icono={<Bell size={20} />}
      descripcion="Recordatorios automáticos y manuales por WhatsApp, correo o SMS. Las citas y vacunas próximas generan recordatorios automáticamente."
      nombreSingular="recordatorio"
      campos={[
        { name: "clienteId", label: "Cliente", type: "select", options: clientes, required: true },
        { name: "mascotaId", label: "Mascota", type: "select", options: mascotas },
        { name: "tipo", label: "Tipo", type: "select", options: tipos, default: "CITA" },
        { name: "canal", label: "Canal", type: "select", options: canales, default: "WHATSAPP" },
        { name: "programadoPara", label: "Enviar el", type: "datetime-local", required: true },
        { name: "mensaje", label: "Mensaje", type: "textarea", required: true, colSpan2: true },
      ]}
      columnas={[
        { key: "cliente", label: "Cliente", render: (r: any) => r.cliente?.nombre },
        { key: "tipo", label: "Tipo" },
        { key: "canal", label: "Canal" },
        { key: "programadoPara", label: "Programado", render: (r: any) => new Date(r.programadoPara).toLocaleString("es-MX") },
        { key: "estado", label: "Estado", render: (r: any) => <Badge color={colorEstado[r.estado] ?? "gris"}>{r.estado}</Badge> },
      ]}
    />
  );
}
